import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiUser, FiBriefcase,   FiArrowUp } from 'react-icons/fi';
import './Footer.css';
import logo from './cresent-2.png'; // Import the logo from the same folder

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-info">
              <Link to="/" className="footer-logo">

              </Link>
              <p className="footer-description">
                Independent intermediary and strategic advisor across global energy, commodities,
                real estate, and joint venture transactions.
              </p>
              <div className="footer-social">

                <a href="mailto:info@crescentadvisory.com" className="social-link">
                  <FiMail />
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-menu">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/advisory-scope">Advisory Scope</Link></li>
                <li><Link to="/engagement-process">Engagement Process</Link></li>
                <li><Link to="/counterparty-profile">Counterparty Profile</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-links">
              <h3 className="footer-title">Advisory Scope</h3>
              <ul className="footer-menu">
                <li><Link to="/advisory-scope#energy">Energy & Oil</Link></li>
                <li><Link to="/advisory-scope#commodities">Commodities & Mining</Link></li>
                <li><Link to="/advisory-scope#real-estate">Real Estate</Link></li>
                <li><Link to="/advisory-scope#joint-ventures">Joint Ventures</Link></li>
                <li><Link to="/investor-portal">Investor Portal</Link></li>
              </ul>
            </div>

            <div className="footer-team">
              <h3 className="footer-title">
                <span className="title-text">Leadership Team</span>
                <span className="title-underline"></span>
              </h3>
              <ul className="team-list">
                <li className="team-item">
                  <div className="team-member">
                    <div className="member-icon">
                      <FiUser />
                    </div>
                    <div className="member-info">
                      <span className="member-name">Mohammed Mahfooz</span>
                      <span className="member-position">CEO & Co-Founder</span>
                      <a href="mailto:Ceo@crescentsadvisory.com" className="member-email">
                        <FiMail className="email-icon" />
                        Ceo@crescentsadvisory.com
                      </a>
                    </div>
                  </div>
                </li>
                <li className="team-item">
                  <div className="team-member">
                    <div className="member-icon">
                      <FiBriefcase />
                    </div>
                    <div className="member-info">
                      <span className="member-name">Aneesa Sheikh</span>
                      <span className="member-position">CSO & Co-Founder</span>
                      <a href="mailto:Aneesa@crescentsadvisory.com" className="member-email">
                        <FiMail className="email-icon" />
                        Aneesa@crescentsadvisory.com
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {new Date().getFullYear()} Innova Core. Developed by Innova Core.
            </p>

            <button className="back-to-top" onClick={scrollToTop} aria-label="Back to top">
              <FiArrowUp />
            </button>
          </div>
        </div>
      </div>


    </footer>
  );
};

export default Footer;